"use client";
import React from "react";
import {useAppDispatch, useAppSelector} from "@/app/hooks";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import Image from "@/app/components/image";
import {Assets} from "@/app/utils/assets";
import Space, {spaceSizes} from "@/app/components/Space";
import PhoneWidget from "src/app/features/auth/pages/phone";
import VerificationWidget from "src/app/features/auth/pages/verification";
import {
  AuthScreenStatus,
  selectAuthStatus,
  setState,
} from "@/app/features/auth/slice";
import styles from "@/app/features/auth/styles.module.scss";
import CreatePinWidget from "src/app/features/auth/pages/create_pin";
import CustomCssTransition from "@/app/components/custom_css_transition/widget";
import WhoAreYouWidget from "src/app/features/auth/pages/who_are_you";
import EnterPinWidget from "@/app/features/auth/pages/enter_pin";

const Page = () => {
  const dispatch = useAppDispatch();
  const authStatus = useAppSelector(selectAuthStatus);

  const changeToPhone = () => {
    dispatch(setState(AuthScreenStatus.PHONE));
  };

  const changeToOTP = () => {
    dispatch(setState(AuthScreenStatus.OTP));
  };

  const changeToPIN = () => {
    dispatch(setState(AuthScreenStatus.PIN));
  };

  return (
    <div className={styles.main}>
      {/*<button onClick={changeToPhone}>Go to PHONE</button>*/}
      {/*<button onClick={changeToOTP}>Go to OTP</button>*/}
      {/*<button onClick={changeToPIN}>Go to PIN</button>*/}
      <Image asset={Assets.liquid} className={styles.liquid}/>
      <Space h={spaceSizes.s50}/>

      <div className={styles.switcherContainer} id="switcherContainer">
        <TransitionGroup component={null}>
          <CustomCssTransition inProp={authStatus === AuthScreenStatus.PHONE}>
            <div className={styles.switcherContent}>
              <PhoneWidget/>
            </div>
          </CustomCssTransition>
          <CustomCssTransition inProp={authStatus === AuthScreenStatus.OTP}>
            <div className={styles.switcherContent}>
              <VerificationWidget/>
            </div>
          </CustomCssTransition>
          <CustomCssTransition inProp={authStatus === AuthScreenStatus.PIN}>
            <div className={styles.switcherContent}>
              <EnterPinWidget/>
            </div>
          </CustomCssTransition>
          <CustomCssTransition inProp={authStatus === AuthScreenStatus.CREATE_PIN}>
          <div className={styles.switcherContent}>
              <CreatePinWidget/>
            </div>
          </CustomCssTransition>
          <CustomCssTransition inProp={authStatus === AuthScreenStatus.WHO_ARE_YOU}>
            <div className={styles.switcherContent}>
              <WhoAreYouWidget/>
            </div>
          </CustomCssTransition>
        </TransitionGroup>
      </div>
    </div>
  );
};

export default Page;